export const dashboard = {
    subtitle: "{{tenant}} · {{date}}",
    quickActions: "দ্রুত কাজ",
    actions: {
        newOrder: "নতুন অর্ডার",
        addProduct: "পণ্য যোগ",
        adjustStock: "স্টক সমন্বয়",
        recordPayment: "পেমেন্ট রেকর্ড",
        posReview: "POS আইটেম রিভিউ",
    },
    attention: "নজর দিতে হবে",
    onboarding: {
        title: "আপনার ব্যবসা চালু করার ধাপ",
        progress: "{{total}}টির মধ্যে {{completed}}টি সম্পন্ন",
        trialEnds: "ট্রায়াল শেষ {{date}}",
        skip: "বাদ দিন",
        dismiss: "লুকান",
        open: "খুলুন",
        loadSamples: "নমুনা পণ্য যোগ করুন",
        samplesLoaded: "{{count}}টি নমুনা পণ্য যোগ হয়েছে।",
        samplesExisting: "নমুনা পণ্যগুলো আগেই যোগ করা আছে।",
        done: "সম্পন্ন",
        skipped: "বাদ দেওয়া",
        steps: {
            business_profile: "লোগো ও ঠিকানা যোগ করুন",
            products: "পণ্য ইমপোর্ট করুন, অথবা নমুনা পণ্য যোগ করুন",
            courier: "কুরিয়ার যুক্ত করুন",
            pos_device: "একটি POS ডিভাইস পেয়ার করুন",
            first_sale: "প্রথম বিক্রি করুন",
        },
    },
    tiles: {
        pendingOrders: "কনফার্ম করার অর্ডার",
        pendingOrdersHint: "কল বা কনফার্মেশনের অপেক্ষায়",
        posReviews: "রিভিউর POS আইটেম",
        posReviewsHint: "সিঙ্কের সময় আটকে বা ফ্ল্যাগ হয়েছে",
        negativeStock: "শূন্যের নিচে স্টক",
        negativeStockHint: "হাতে যা ছিল তার বেশি বিক্রি হয়েছে",
    },
    moreThan: "{{count}}+",
    sales: {
        title: "বিক্রি",
        period: "সময়কাল",
        location: "শাখা",
        allLocations: "সব শাখা",
        periods: {
            today: "আজ",
            yesterday: "গতকাল",
            last7: "গত ৭ দিন",
            thisMonth: "এই মাস",
            lastMonth: "গত মাস",
        },
        netSales: "নিট বিক্রি",
        orders: "অর্ডার",
        averageOrder: "গড় অর্ডার",
        grossProfit: "মোট লাভ",
        margin: "{{margin}} মার্জিন",
        change: "আগের সময়ের তুলনায় {{change}}",
        noChange: "আগের সময়ে কোনো বিক্রি নেই",
        chart: "দিনভিত্তিক নিট বিক্রি",
        chartEmpty: "এই সময়ে এখনো কোনো বিক্রি নেই।",
        chartBar: "{{date}}: {{orders}}টি অর্ডারে {{amount}}",
        channels: "চ্যানেল",
        topProducts: "সেরা পণ্য",
        noProducts: "এই সময়ে কিছু বিক্রি হয়নি।",
        qty: "পরিমাণ",
        amount: "বিক্রি",
        lowStock: "কম বা ঋণাত্মক স্টক",
        lowStockHint: "{{negative}}টি শূন্যের নিচে · {{low}}টি রি-অর্ডার সীমায়",
        toShip: "পাঠানোর অর্ডার",
        toShipHint: "{{pending}}টি এখনো নিশ্চিত করা বাকি",
        codHeld: "কুরিয়ারের কাছে COD",
        codHeldHint: "{{parcels}}টি ডেলিভারি পার্সেলের টাকা আসেনি",
        live: "সরাসরি আপডেট",
        channelNames: {
            pos: "কাউন্টার (POS)",
            manual: "ম্যানুয়াল",
            facebook: "ফেসবুক",
            whatsapp: "হোয়াটসঅ্যাপ",
            phone: "ফোন",
            storefront: "ওয়েবসাইট",
        },
    },
    recentOrders: "সাম্প্রতিক অর্ডার",
    viewAll: "সব দেখুন",
    noOrders: "এখনো কোনো অর্ডার নেই",
    noOrdersBody: "ওয়েবসাইট, ফোন ও কাউন্টারের অর্ডার এখানে দেখা যাবে।",
    columns: { number: "অর্ডার", customer: "কাস্টমার", status: "অবস্থা", total: "মোট", when: "কখন" },
};
//# sourceMappingURL=dashboard.js.map